import React from "react";
import { Choose, ChooseOption, Form } from "@xala/common-ui";
import { useTranslation } from "react-i18next";
import {
  NotificationProvidersService,
  useDataLoader,
  INotificationProviderSegmentModel,
} from "@xala/common-services";
import { INotificationField } from "./INotificationField";

const notificationProviderService = new NotificationProvidersService().promisify();

export const NotificationProviderSegmentsField = ({
  notification,
  isEditMode,
  isHidden,
}: INotificationField) => {
  const { t } = useTranslation();
  const notificationsProviderSegmentsLoader = useDataLoader({
    loader: () => notificationProviderService.getSegments(),
    deps: [],
  });

  if (isHidden) {
    return null;
  }

  return (
    <Form.Item
      name="SegmentId"
      label={t("NOTIFICATION_PROVIDER_SEGMENTS_FIELD")}
      key="SegmentId"
      initialValue={ isEditMode ? notification?.SegmentId || "" : ""}
    >
      <Choose
        placeholder={t("NOTIFICATION_PROVIDER_SEGMENTS_INPUT_FIELD")}
        key="SegmentId"
      >
        { notificationsProviderSegmentsLoader.data?.segments?.map(
          (segment: INotificationProviderSegmentModel) => (
            <ChooseOption key={segment.id} value={segment.id}>
              {segment.name}
            </ChooseOption>
          )
        )}
      </Choose>
    </Form.Item>
  );
};
